import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'isPublisherUser',
    ]),
  },

  created() {
    if (!this.isPublisherUser) {
      this.$router.replace('/library');
    }
  },
};



// WEBPACK FOOTER //
// ./src/mixins/publisherOnly.js